export default __webpack_public_path__ + "media/images/instagram-social-fcb4d2654780b585dcba924228014645.svg";